import React from "react";
import styles from "./Destinations3.module.css";

const fallbackImages = [
  "/assets/images/default-package.jpg",
  "/assets/images/default-package2.png",
  "/assets/images/default-package3.png",
  "/assets/images/default-package4.png",
  "/assets/images/default-package5.png",
  "/assets/images/default-package6.jpg"
];

const Destinations3 = ({ destinations = [] }) => {
  if (!destinations || destinations.length === 0) return null;

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.textCenter}>
          <h2 className={styles.title}>Top Destinations</h2>
          <div className={styles.divider}></div>
        </div>

        <div className={styles.flexContainer}>
          {destinations.slice(0, 6).map((dest, index) => {

            const fallbackImage =
              fallbackImages[index % fallbackImages.length];

            const imageUrl =
              dest?.image && dest.image.trim() !== ""
                ? dest.image
                : fallbackImage;

            return (
              <div key={index} className={styles.card}>
                <div className={styles.imgWrapper}>
                  <img
                    src={imageUrl}
                    alt={dest?.name || "Destination"}
                    className={styles.image}
                    onError={(e) => {
                      e.target.src = fallbackImage;
                    }}
                  />
                </div>

                <h3 className={styles.name}>
                  {dest?.name || "Explore Destination"}
                </h3>

                <p className={styles.link}>View Packages &rarr;</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Destinations3;